import React from "react";
import { Logo } from "./Logo";

export const Footer = ({ t }) => {
  const f = t.footer;
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  const navLinks = [
    { id: "about", label: t.nav.about },
    { id: "services", label: t.nav.services },
    { id: "values", label: t.nav.values },
    { id: "vision", label: t.nav.vision },
    { id: "contact", label: t.nav.contact },
  ];

  return (
    <footer data-testid="footer" className="bg-aa-green border-t border-aa-gold/20">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <Logo className="h-11" />
          <p className="font-body font-light text-aa-cream/60 mt-6 text-sm max-w-xs leading-relaxed">
            {f.slogan}
          </p>
        </div>

        <div>
          <div className="font-heading text-xs uppercase tracking-[0.22em] text-aa-gold">{f.nav}</div>
          <div className="mt-5 flex flex-col gap-3">
            {navLinks.map((l) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                data-testid={`footer-nav-${l.id}`}
                className="text-left font-body text-sm text-aa-cream/70 hover:text-aa-gold transition-colors w-fit"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>

        <div>
          <div className="font-heading text-xs uppercase tracking-[0.22em] text-aa-gold">{f.contact}</div>
          <div className="mt-5 flex flex-col gap-3 font-body text-sm text-aa-cream/70">
            <a href="https://maps.google.com/?q=Riviera+Mbadon" target="_blank" rel="noreferrer" className="hover:text-aa-gold transition-colors">Riviera Mbadon</a>
            <a href="tel:+2250789880088" className="hover:text-aa-gold transition-colors">07 89 88 00 88</a>
            <a href="mailto:sales@2aimmob.com" className="hover:text-aa-gold transition-colors">sales@2aimmob.com</a>
            <a href="https://www.2aimmob.com" target="_blank" rel="noreferrer" className="hover:text-aa-gold transition-colors">www.2aimmob.com</a>
          </div>
        </div>
      </div>

      <div className="diamond-strip opacity-40" />
      <div className="border-t border-aa-gold/10">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-body text-xs text-aa-cream/50">
            © {new Date().getFullYear()} A&A Immobiliers. {f.rights}
          </p>
          <p className="font-body text-xs uppercase tracking-[0.2em] text-aa-gold/70">{f.tagline}</p>
        </div>
      </div>
    </footer>
  );
};
